let isSorting = false;
let allPagesFetched = false;

function isProductInStock(productElement) {
  const inventoryAttr = productElement.getAttribute('data-inventory');
  if (inventoryAttr !== null) {
    const inventory = parseInt(inventoryAttr);
    if (inventory <= 0) return false;
    if (inventory > 0) return true;
  }
  const soldOutSelectors = [
    '.sold-out', '.out-of-stock', '[class*="sold-out"]',
    '[class*="out-of-stock"]', '.product-form__error-message',
    '[data-availability="sold-out"]'
  ];
  for (const sel of soldOutSelectors) {
    if (productElement.querySelector(sel)) return false;
  }
  if (productElement.classList.contains('sold-out') || productElement.classList.contains('out-of-stock')) {
    return false;
  }
  const addButton = productElement.querySelector(
    'button[name="add"], .add-to-cart, button[type="submit"], .quick-add__submit'
  );
  if (addButton) {
    const txt = addButton.textContent.trim().toLowerCase();
    if (txt.includes('sold out') || txt.includes('out of stock') || txt.includes('unavailable')) return false;
    if (addButton.disabled) return false;
  }
  try {
    const productData = productElement.querySelector('script[type="application/json"]');
    if (productData) {
      const data = JSON.parse(productData.textContent);
      if (data.available === false) return false;
      if (data.variants && Array.isArray(data.variants)) {
        const allUnavailable = data.variants.every(v => v.available === false);
        if (allUnavailable) return false;
      }
    }
  } catch (e) {}
  const text = productElement.textContent.toLowerCase();
  if (text.includes('sold out') || text.includes('out of stock')) {
    const badges = productElement.querySelectorAll('.badge, .product-badge, [class*="badge"]');
    for (const badge of badges) {
      const badgeText = badge.textContent.toLowerCase();
      if (badgeText.includes('sold out') || badgeText.includes('out of stock')) return false;
    }
  }
  return true;
}

function getProductDiscount(productElement) {
  const discountAttr = productElement.getAttribute('data-discount');
  return discountAttr ? parseFloat(discountAttr) : 0;
}

function isSaleCollection() {
  const container = document.querySelector('[data-collection-handle]');
  if (!container) return false;
  const handle = container.getAttribute('data-collection-handle');
  return handle && handle.toLowerCase().includes('sale');
}

// By default this function will only process the current page (fast UX).
// To perform a full collection crawl pass { full: true }.
async function sortCollectionByStockIncremental(options = {}) {
  const { full = false } = options;
  if (isSorting || allPagesFetched) {
    console.log('⚠️ Already sorting or completed');
    return;
  }
  isSorting = true;
  window.isSorting = true;
  
  const isSale = isSaleCollection();
  console.log(`🔄 Starting incremental ${isSale ? 'discount & ' : ''}stock-based sorting...`);
  
  const mainGrid = document.querySelector('.collection #product-grid');
  if (!mainGrid) {
    console.error('❌ Product grid not found');
    isSorting = false;
    return;
  }
  // Ensure an out-of-stock container exists (hidden by default)
  let outOfStockContainer = document.querySelector('.collection #product-grid-outofstock');
  if (!outOfStockContainer) {
    outOfStockContainer = document.createElement('ul');
    outOfStockContainer.id = 'product-grid-outofstock';
    outOfStockContainer.style.display = 'none';
    outOfStockContainer.className = mainGrid.className || '';
    mainGrid.parentNode.insertBefore(outOfStockContainer, mainGrid.nextSibling);
  }
  const spinner = createLoadingSpinner();
  const container = mainGrid.closest('.collection') || mainGrid.parentElement;
  container.appendChild(spinner);
  const loadingOverlay = document.querySelector('.collection .loading-overlay');
  if (loadingOverlay) {
    loadingOverlay.classList.add('gradient');
    loadingOverlay.style.opacity = '1';
    loadingOverlay.style.visibility = 'visible';
  }
  
  const inStockProducts = [];
  const outOfStockProducts = [];
  const firstPageProducts = Array.from(mainGrid.querySelectorAll('li.grid__item'));
  
  // Process first page products
  firstPageProducts.forEach(p => {
    if (isProductInStock(p)) {
      p.classList.add('in-stock-item');
      p.classList.remove('out-of-stock-item');
      inStockProducts.push(p);
    } else {
      p.classList.add('out-of-stock-item');
      p.classList.remove('in-stock-item');
      p.style.display = 'none';
      outOfStockProducts.push(p);
    }
  });
  
  console.log(`📦 Page 1: ${inStockProducts.length} in-stock, ${outOfStockProducts.length} out-of-stock`);
  updateLoadingMessage(spinner, `Found ${inStockProducts.length} in-stock products...`);
  
  // Render first page immediately for better UX
  if (isSale && inStockProducts.length > 0) {
    inStockProducts.sort((a, b) => {
      const discountA = getProductDiscount(a);
      const discountB = getProductDiscount(b);
      return discountB - discountA;
    });
  }
  
  // Build the first page view (fast)
  mainGrid.innerHTML = '';
  const firstPageFrag = document.createDocumentFragment();
  inStockProducts.forEach(p => {
    p.style.display = '';
    firstPageFrag.appendChild(p);
  });
  mainGrid.appendChild(firstPageFrag);

  // If the caller requested a full crawl, continue fetching remaining pages.
  if (!full) {
    // Do not fetch other pages — rely on incremental loading (infinite scroll)
    // and the per-batch reorder already in place in custom-collection.js
    console.log('ℹ️ Batch mode: processed current page only (no full crawl)');
  // Move out-of-stock products into the hidden out-of-stock container so they
  // don't appear mid-pagination. They will be appended when the crawl finishes
  // or when you explicitly merge the containers.
  const outFrag = document.createDocumentFragment();
  outOfStockProducts.forEach(p => { p.style.display = ''; outFrag.appendChild(p); });
  outOfStockContainer.appendChild(outFrag);
    // cleanup spinner and state
    if (spinner) spinner.remove();
    isSorting = false;
    window.isSorting = false;
    window.dispatchEvent(new CustomEvent('stockSortingComplete', { detail: { inStock: inStockProducts.length, outOfStock: outOfStockProducts.length, isSale } }));
    return;
  }
  
  console.log(`📊 Final: ${inStockProducts.length} in-stock, ${outOfStockProducts.length} out-of-stock`);
  
  // Remove loading placeholder
  const placeholder = mainGrid.querySelector('.loading-more-products');
  if (placeholder) placeholder.remove();
  
  // Only re-sort all if it's a sale collection (otherwise already appended in order)
  if (isSale) {
    updateLoadingMessage(spinner, 'Final sorting by discount...');
    inStockProducts.sort((a, b) => {
      const discountA = getProductDiscount(a);
      const discountB = getProductDiscount(b);
      return discountB - discountA;
    });
    
    // Rebuild grid with final sorted order
    mainGrid.innerHTML = '';
    const finalFrag = document.createDocumentFragment();
    inStockProducts.forEach(p => {
      p.style.display = '';
      finalFrag.appendChild(p);
    });
    mainGrid.appendChild(finalFrag);
  }
  
  // Add out-of-stock products at the end: move hidden container children into main grid
  updateLoadingMessage(spinner, 'Adding out-of-stock products...');
  const hidden = document.querySelector('.collection #product-grid-outofstock');
  if (hidden) {
    const moveFrag = document.createDocumentFragment();
    Array.from(hidden.children).forEach(ch => moveFrag.appendChild(ch));
    mainGrid.appendChild(moveFrag);
    hidden.remove();
  } else {
    // fallback: append collected outOfStockProducts
    const outOfStockFrag = document.createDocumentFragment();
    outOfStockProducts.forEach(p => { p.style.display = ''; outOfStockFrag.appendChild(p); });
    mainGrid.appendChild(outOfStockFrag);
  }
  
  updateLoadingMessage(spinner, 'Finalizing...');
  
  const pagination = document.querySelector('#product-grid-Pagination');
  if (pagination) pagination.style.display = 'none';
  if (window.infiniteScrollObserver) window.infiniteScrollObserver.disconnect?.();
  if (window.toggleInfiniteScroll) window.toggleInfiniteScroll(false);
  
  if (loadingOverlay) {
    loadingOverlay.classList.remove('gradient');
    loadingOverlay.style.opacity = '0';
    loadingOverlay.style.visibility = 'hidden';
  }
  
  setTimeout(() => {
    spinner.style.opacity = '0';
    spinner.style.transform = 'translateY(20px)';
    setTimeout(() => spinner.remove(), 300);
  }, 500);
  
  if (window.onLoadGridSwitcher) setTimeout(() => window.onLoadGridSwitcher(), 100);
  if (typeof ReloadSmartWishlist !== 'undefined') ReloadSmartWishlist();
  
  allPagesFetched = true;
  isSorting = false;
  window.allPagesFetched = true;
  window.isSorting = false;
  
  console.log(`✨ ${isSale ? 'Discount & stock' : 'Stock'} sorting completed!`);
  window.dispatchEvent(new CustomEvent('stockSortingComplete', {
    detail: { inStock: inStockProducts.length, outOfStock: outOfStockProducts.length, isSale }
  }));
}

function createLoadingSpinner() {
  const el = document.createElement('div');
  el.id = 'stock-sort-loader';
  el.innerHTML = `
    <div class="spinner-content">
      <div class="spinner-ring">
        <div></div><div></div><div></div><div></div>
      </div>
      <p class="spinner-message">Loading products...</p>
      <div class="spinner-progress"><div class="progress-bar"></div></div>
    </div>
  `;
  if (!document.querySelector('#stock-sort-loader-styles')) {
    const style = document.createElement('style');
    style.id = 'stock-sort-loader-styles';
    style.textContent = `
      #stock-sort-loader {
        width:100%;padding:40px 20px;margin:20px 0;
        text-align:center;background:rgba(255,255,255,0.9);
        border-radius:12px;border:1px solid rgba(0,0,0,0.1);
        transition:all .3s ease;opacity:1;transform:translateY(0);
      }
      .spinner-ring{display:inline-block;position:relative;width:48px;height:48px;margin-bottom:16px;}
      .spinner-ring div{box-sizing:border-box;display:block;position:absolute;width:38px;height:38px;margin:5px;border:4px solid;
        border-radius:50%;animation:spinner-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#cb7040 transparent transparent transparent;}
      .spinner-ring div:nth-child(1){animation-delay:-.45s;}
      .spinner-ring div:nth-child(2){animation-delay:-.3s;}
      .spinner-ring div:nth-child(3){animation-delay:-.15s;}
      @keyframes spinner-ring{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}
      .spinner-message{margin:0 0 12px;font-size:14px;font-weight:500;color:#333;}
      .spinner-progress{width:100%;height:3px;background:#f0f0f0;border-radius:2px;overflow:hidden;}
      .progress-bar{height:100%;background:linear-gradient(90deg,#cb7040,#ff8c5a);
        border-radius:2px;width:0%;transition:width .3s ease;animation:progress-pulse 1.5s ease-in-out infinite;}
      @keyframes progress-pulse{0%,100%{opacity:1;}50%{opacity:.6;}}
      @media(max-width:768px){#stock-sort-loader{padding:30px 15px;margin:15px 0;}
        .spinner-ring{width:40px;height:40px;}
        .spinner-ring div{width:32px;height:32px;border-width:3px;}
        .spinner-message{font-size:13px;}}
    `;
    document.head.appendChild(style);
  }
  return el;
}

function updateLoadingMessage(spinner, msg) {
  const msgEl = spinner.querySelector('.spinner-message');
  if (msgEl) msgEl.textContent = msg;
  const bar = spinner.querySelector('.progress-bar');
  if (!bar) return;
  if (msg.includes('page 1') || msg.includes('Found')) bar.style.width = '20%';
  else if (msg.includes('Fetching')) bar.style.width = '40%';
  else if (msg.includes('Loaded')) bar.style.width = '60%';
  else if (msg.includes('Sorting')) bar.style.width = '75%';
  else if (msg.includes('Adding products')) bar.style.width = '85%';
  else if (msg.includes('out-of-stock')) bar.style.width = '95%';
  else if (msg.includes('Finalizing')) bar.style.width = '100%';
}

// Do not automatically start a full collection crawl on load.
// Call `window.sortCollectionByStock()` to process the current page only (fast).
// Call `window.sortCollectionByStockFull()` to perform the full collection crawl (slow).
window.sortCollectionByStock = function() { return sortCollectionByStockIncremental({ full: false }); };
window.sortCollectionByStockFull = function() { return sortCollectionByStockIncremental({ full: true }); };
window.allPagesFetched = allPagesFetched;
window.isSorting = isSorting;
